import { MakeCall } from './createMakeCall';

export interface ResponseObject {
  Rooms: number;
  Cities: number;
  Countries: number;
}

export default (makeCall: MakeCall) => () =>
  makeCall<ResponseObject>('GET', `/api/v2/listings/global-counters`);
